import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';
import { token } from '@atlaskit/tokens';
import { ThemedButton } from '@atlassian/help-center-common-component/themed-button';

// eslint-disable-next-line rulesdir/no-styled-export
export const ExternalLinksWrapper = styled.div`
    ul {
        padding-left: ${token('space.0', '0px')};
    }

    h3 {
        ${fonts.h500};
        margin-bottom: ${token('space.200', '16px')};
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const LabelWithIcon = styled.label`
    display: flex;
    align-items: center;

    > :not(:last-child) {
        margin-right: ${token('space.100', '8px')};
    }
`;

//@ts-ignore TypeScript upgrade 5.1.6, please fix this violation.
// eslint-disable-next-line rulesdir/no-styled-export
export const ShowMoreButton = styled(ThemedButton)`
    margin-top: ${token('space.100', '8px')};
    &:hover {
        text-decoration: none;
    }
`;
